<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper" v-if="!DisabledEvaluationDate">
                  <label for="evaluationDate">Evaluation Years</label>
                  <a-select
                    placeholder="Select Evaluation Years"
                    v-model="evaluationDate"
                    class="width-full"
                    allowClear
                    showSearch
                  >
                    <a-select-option
                      v-for="item in listYear"
                      :key="item"
                      :value="item"
                      >{{ item }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="rating">Rating</label>
                  <a-select
                    placeholder="Choose Rating "
                    v-model="rating"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option  :key="1" value="obj.rating_value >12">
                      <Rating :rating="'12'" />
                    </a-select-option>
                    <a-select-option  :key="2" value="obj.rating_value  < 12 && obj.rating_value  >= 9">
                      <Rating :rating="'9'" />
                    </a-select-option>
                    <a-select-option  :key="3" value="obj.rating_value  < 9 && obj.rating_value  >= 6">
                      <Rating :rating="'6'" />
                    </a-select-option>
                    <a-select-option  :key="4" value="obj.rating_value  < 6 && obj.rating_value  >= 3">
                      <Rating :rating="'3'" />
                    </a-select-option>
                    <a-select-option  :key="5" value="obj.rating_value  < 3 || isNaN(obj.rating_value)">
                      <Rating :rating="'1'" />
                    </a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Avionik ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getSupplierType"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        :tabbedTransactional="true"
        title="Supplier Evaluation List"
        dataListTitle="Evaluation List"
        dataDraftTitle="Need Evaluation List"
        :manifestLink="'supplierEvaluation-manifest'+menutype"
        :disabledCreateEditLink="false"
        :notCreate="true"
        :allowcancel="true"
        :draftCreateLink="menutype=='Fin' ? false : 'supplierEvaluation-create'+menutype"
        :editLink="'supplierEvaluation-edit'+menutype"
        :rating="true"
        :dataList="searching"
        :draftList="searchingDraft"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";
import _ from "lodash";
import Rating from "@/components/Rating.vue";

export default {
  name: "Supplier",
  components: {
    Rating,
  },
  data() {
    return {
      loading: true,
      purchasingList: [],
      purchasingNeedEval: [],
      storeList: [],
      search: "",
      searchDate: null,
      evaluationDate:undefined,
      status: undefined,
      rating: undefined,
      kategori: undefined,
      pagination: {
        pageSize: 5,
        size: "small",
      },
      DisabledEvaluationDate:false,
      listYear:[],
    };
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getSupplierType", "getStatus"]),
    searching() {
      let output = this.purchasingList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            (obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)

        );
      }

      if (this.kategori) {
        let filterKategori = this.kategori;
        output = output.filter(
          (objDt) =>
            objDt.kategori &&
            objDt.kategori.toLowerCase() === filterKategori.toLowerCase()
        );
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.evaluationDate) {
        output = output.filter(
          (obj) =>
            obj.tahun &&
            obj.tahun==moment(this.evaluationDate).format('YYYY').toString()
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tanggal === searchDate);
      }

      if(this.rating){
        eval("output = output.filter((obj) => "+this.rating+");");
      }

      return output;
    },
    searchingDraft(){
      let output = this.purchasingNeedEval;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        let filterKategori = this.kategori;
        output = output.filter(
          (objDt) =>
            objDt.kategori &&
            objDt.kategori.toLowerCase() === filterKategori.toLowerCase()
        );
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tanggal === searchDate);
      }

      return output;
    },
    menutype(){
      let key = localStorage.getItem("nvky");
      if (key==47){
        return 'Purchasing';
      }else if(key==73){
        return 'GA';
      }else if(key==145){
        return 'Fin';
      }else{
        return '';
      }
    }
  },
  methods: {
    fetchPurchasing() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "evaluasi_suplier",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.storeList = response.data;
          this.storeList.list_evaluasi.forEach((data) => {
            this.purchasingList.push({
              title: data.no_trans+" ["+data.user_pembuat+"]",
              subtitle: data.nama,
              subdesc: [data.alamat,data.kategori,data.jenis_produk],
              status: data.status_besar,
              id: data.id_eval_supplier,
              rating_value: data.nilai_evaluasi,
              timeline: JSON.parse(data.status_app),
              tahun: data.tahun,
              searchQ:
                data.no_trans + " " +
                data.nama + " " +
                data.alamat + " " +
                data.kategori + " " +
                data.jenis_produk,
              no_trans_toCancel: data.no_trans,
              cancelStatus: data.status_besar,
              kategori: data.kategori
            });
          });
          let tempYear = _.uniq(_.map(this.purchasingList, "tahun"));

          // let thnExist = moment().format('YYYY').toString();
          // while (thnExist!=null) {
          //   let filtData = _.filter(tempYear, (obj) => obj==thnExist);
          //   if (filtData.length>0){
          //     thnExist = null
          //   }else{
          //     tempYear.push(thnExist);
          //     thnExist = thnExist-1;
          //   }
          // }
          this.listYear = tempYear.sort((a,b) => parseInt(b) - parseInt(a) );

          this.storeList.need_evaluasi.forEach((data) => {
            this.purchasingNeedEval.push({
              title: data.nama_perusahaan,
                subdesc: [
                  data.alamat,data.kategori,data.jenis_produk
                ],
                id: data.id_supplier,
                searchQ:
                  data.nama_perusahaan + " " +
                  data.alamat + " " +
                  data.kategori + " " +
                  data.jenis_produk,
                kategori : data.kategori
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    clickTabed(val){
      this.evaluationDate = undefined;
      if(val=='list'){
        this.DisabledEvaluationDate = false;
      }else{
        this.DisabledEvaluationDate = true;
      }
    },
    canceltrans(item) {
      //console.log(item)
      Event.$emit("loadDatalistcancel", true);
      Axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        responseType: "blob",
        data: {
          jenis_trans: "evaluasi_suplier",
          id_manifest: item.id,
          tlc: this.getAuth.username,
          code_trans: item.no_trans_toCancel,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          Event.$emit("loadDatalistcancel", false);
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go(0);
        })
        .catch((err) => {
          Event.$emit("loadDatalistcancel", false);
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.push({ name: "beranda" });
          }
        });
    },
  },
  mounted() {
    Event.$on("callbackTab", this.clickTabed);
    Event.$on("handleCancel", this.canceltrans);
    this.fetchPurchasing();
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleCancel", this.canceltrans);
  },
};
</script>

<style>
</style>